export default __webpack_public_path__ + "static/media/quiz.bdf3c045.svg";